import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { USE_MOCK } from '@/config'
import { createClient } from '@/api/supabase'

/**
 * Подписка на новые сообщения чата заказа. На каждый INSERT/UPDATE/DELETE
 * в order_chat_messages с filter=order_id=eq.<id> инвалидирует react-query
 * ключ ['chat-messages', orderId]. Канал — отдельный на каждое монтирование.
 *
 * Таблица order_chat_messages уже в публикации supabase_realtime.
 */
export function useChatRealtime(orderId: string | undefined): void {
  const qc = useQueryClient()

  useEffect(() => {
    if (USE_MOCK || !orderId) return
    const sb = createClient()
    const ch = sb
      .channel(`order-chat-${orderId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'order_chat_messages',
          filter: `order_id=eq.${orderId}`,
        },
        () => {
          void qc.invalidateQueries({ queryKey: ['order-chat', orderId] })
        },
      )
      .subscribe()

    return () => {
      try {
        void sb.removeChannel(ch)
      } catch {
        // ignore
      }
    }
  }, [qc, orderId])
}
